import { useEffect } from "react";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import { extractContentFromTag } from "../../../utils/extractContentFromTag.ts";
import useFetch, { ExtendedCacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { Hall } from "./type.ts";

const useHalls = () => {
  const fetch = useFetch();

  const { data, isLoading, isError, error } = useQuery<
    {
      halls: Hall[];
    } | null,
    Error,
    Hall[]
  >({
    queryKey: ["halls"],
    select: (res) =>
      res?.halls.map((el) => {
        return {
          ...el,
          information: extractContentFromTag(el.information),
        } as Hall;
      }) || [],
    queryFn: () =>
      fetch<{
        halls: Hall[];
      }>(Urls.Halls, {
        method: "GET",
      }),
    gcTime: ExtendedCacheTime,
    staleTime: ExtendedCacheTime,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting halls");
    }
  }, [error?.message, isError]);

  return {
    halls: data,
    isFetching: isLoading,
  };
};

export default useHalls;
